import { Flex, Box } from '@cad-arc';
import { Control, FieldArrayPath, useFieldArray } from 'react-hook-form';
import { INPUT_WIDTH_SM, DEFAULT_MAX_GROUPS } from '../../search-windows/constants';
import { FormButton, FormInputIconButton } from '../integrated-form-components/form-button';
import { FormInput } from './form-input';

export function FormNInputGroups<FormType>({
    groupName,
    properties,
    groupLabel,
    control,
    buttonSize,
    maxGroups = DEFAULT_MAX_GROUPS,
}: {
    groupName: FieldArrayPath<FormType>;
    groupLabel: string;
    properties: {
        propertyName: string;
        propertyLabel: string;
    }[];
    control: Control<FormType>;
    maxGroups?: number;
    buttonSize?: 'sm' | 'md' | 'lg' | 'xl';
}) {
    const { fields, append, remove } = useFieldArray({
        control,
        name: groupName,
    });

    return (
            <Flex flexDirection="column" flex={1} gap={4}>
                {fields.map((field, index) => {
                    const showTrashCan = fields.length > 1;
                    return (
                        <Flex key={field.id} flex={1} gap={4} flexFlow="wrap">
                            <>
                                {properties.map(({ propertyName, propertyLabel }) => {
                                    return (
                                        <Box
                                            flex={1}
                                            minWidth={INPUT_WIDTH_SM}
                                            maxWidth={INPUT_WIDTH_SM}
                                            key={`${propertyName}-${index}`}
                                        >
                                            <FormInput
                                                // @ts-expect-error propertyName not typed correctly
                                                name={`${groupName}.${index}.${propertyName}`}
                                                label={propertyLabel}
                                                control={control}
                                            />
                                        </Box>
                                    );
                                })}
                                {showTrashCan && (
                                    <Box flex={0}>
                                        <FormInputIconButton
                                            showInline
                                            variant="ghost"
                                            icon="TrashCan"
                                            size={buttonSize}
                                            data-testid="remove-field"
                                            aria-label={`remove ${groupLabel}`}
                                            onClick={() => remove(index)}
                                            style={{
                                                width: '30px',
                                                alignSelf: 'flex-end',
                                            }}
                                        />
                                    </Box>
                                )}
                            </>
                            {index === fields.length - 1 && (
                                <Box flex={1} minWidth="10rem" maxWidth="15rem">
                                    <FormButton
                                        showInline
                                        variant="outline"
                                        leadingVisual="Add"
                                        size={buttonSize}
                                        onClick={() =>
                                            append(
                                                // @ts-expect-error propertyName not typed correctly
                                                Object.fromEntries(
                                                    properties.map(({ propertyName }) => [
                                                        propertyName,
                                                        '',
                                                    ])
                                                )
                                            )
                                        }
                                        disabled={fields.length >= maxGroups}
                                    >
                                        Additional {groupLabel}
                                    </FormButton>
                                </Box>
                            )}
                        </Flex>
                    );
                })}
            </Flex>
    );
}
